import { AnimationBaseController, IAnimationControllerConfiguration, Inject, IBaseController } from "@denishussar/html5-game-engine";
import { PlayerTurnConstant } from "../../../Constants/PlayerTurnConstant";
import { HIT_FOR_ROUND } from "../../../Constants/RulesCommonConstants";
import { DropDownScoreLog, GameModel, IScoreLogItem } from "../../../Models/GameModel";
import { AnimationContents } from "../../AnimationContents";
import { IRawControllerOptions, RawController } from "./RawController";
import { IRoundRawControllerOptions, RoundRawController } from "./RoundRawController";

export class RawContainerController extends AnimationBaseController {
    $model: GameModel;

    private _kykkaItemsA: IBaseController[] = [];
    private _kykkaItemsB: IBaseController[] = [];

    public constructor(@Inject private _options: any) {
        super("RawContainerController");
        console.log('RawContainerController', this);


    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {

        }
    }

    protected onInitialize(): void {
        // this.setData();
    }

    setData(scoresLog: DropDownScoreLog[]) {

        while (this.$childControllers.items.count()){
            this.removeChildControllerByName(this.$childControllers.items.last().name);
        }
        if (!scoresLog.length) {
            return;
        }
        // scoresLog = [

        //     {
        //         list: [
        //             { city: 4, line: 2, edge: 3, total: 5, delta: 1, player: 0 },
        //             { city: 5, line: 3, edge: 4, total: 6, delta: 2, player: 0 },
        //             { city: 6, line: 4, edge: 5, total: 7, delta: 3, player: 1 },
        //             { city: 7, line: 5, edge: 6, total: 8, delta: 4, player: 1 },
        //             { city: 8, line: 4, edge: 5, total: 7, delta: 5, player: 0 },
        //             { city: 9, line: 5, edge: 6, total: 8, delta: 6, player: 0 },
        //             { city: 10, line: 5, edge: 6, total: 8, delta: 7, player: 1 },
        //         ],
        //         complete: false
        //     },
        //     {
        //         list: [
        //             { city: 4, line: 2, edge: 3, total: 5, delta: 1, player: 0 },
        //             { city: 5, line: 3, edge: 4, total: 6, delta: 2, player: 0 },
        //             { city: 6, line: 4, edge: 5, total: 7, delta: 3, player: 1 },
        //             { city: 7, line: 5, edge: 6, total: 8, delta: 4, player: 1 },
        //             { city: 8, line: 4, edge: 5, total: 7, delta: 5, player: 0 },
        //             { city: 9, line: 5, edge: 6, total: 8, delta: 6, player: 0 },
        //             { city: 10, line: 5, edge: 6, total: 8, delta: 7, player: 1 },
        //             { city: 11, line: 5, edge: 6, total: 8, delta: 8, player: 1 },
        //             { city: 10, line: 5, edge: 6, total: 8, delta: 9, player: 0 },
        //             { city: 11, line: 5, edge: 6, total: 8, delta: 10, player: 0 },
        //             { city: 10, line: 5, edge: 6, total: 8, delta: 11, player: 1 },
        //             { city: 11, line: 5, edge: 6, total: 8, delta: 12, player: 1 },
        //         ],
        //         complete: true
        //     },
        // ];

        let y = 0;
        // let i = 0;
        // let roundPlateCounter = 0;
        // const rawsTotal = scoresLog.length + Math.floor(scoresLog.length / (HIT_FOR_ROUND*2));
        // let isDrawnPlate = false;

        for (let roundIndex = 0; roundIndex < scoresLog.length; roundIndex++) {
            const round = scoresLog[roundIndex];
            if (round.complete) {
                this.addChildController({
                    animationContent: AnimationContents.TABLO_SCREEN_JSON,
                    libraryName: "round_raw",
                    view: RoundRawController,
                    model: this.$model,
                    y,
                    options: <IRoundRawControllerOptions>{
                        scoreA: this.$model.playerA.roundsScoresLog[scoresLog.length - roundIndex - 1],
                        scoreB: this.$model.playerB.roundsScoresLog[scoresLog.length - roundIndex - 1]
                    }
                }, `RoundRawController-${roundIndex}`);
                y += 60;
            }

            for (let rawIndex = 0; rawIndex < scoresLog[roundIndex].list.length; rawIndex++) {
                const rawLog = scoresLog[roundIndex].list[rawIndex];
                const raw = [rawLog];
                if (scoresLog[roundIndex].list[rawIndex + 1] && scoresLog[roundIndex].list[rawIndex + 1].player === scoresLog[roundIndex].list[rawIndex].player) {
                    raw.push(scoresLog[roundIndex].list[rawIndex + 1]);
                    rawIndex++;
                }
                const moveNumber = (raw.length === 1)
                    ? [scoresLog[roundIndex].list.length - rawIndex]
                    : [scoresLog[roundIndex].list.length - rawIndex + 1, scoresLog[roundIndex].list.length - rawIndex];

                this.addChildController({
                    animationContent: AnimationContents.TABLO_SCREEN_JSON,
                    libraryName: "raw",
                    view: RawController,
                    model: this.$model,
                    y,
                    options: <IRawControllerOptions>{
                        raw,
                        hasBg: raw[0].player === PlayerTurnConstant.A,
                        moveNumber
                    }
                }, `Raw-${roundIndex}-${rawIndex}`);
                y += (raw.length === 1) ? 65 : 110;
            }

        }
    }

}